import fetchJSON from '../fetchJSON'

export interface Community {
  id: number
  title: string
  description: string
  alias: string
  entryCount: number
  childCount: number
  enabled: boolean
  primary: boolean
  children?: Community[]
}


export interface CommunitiesResponse {
  communities: Community[] | []
}

export const defaultState: CommunitiesResponse = {
  communities: []
}


async function fetchWebcastCommunities (channelId = '', webcastId = '', hostUrl = ''): Promise<CommunitiesResponse> {

  if (!channelId || !webcastId) return defaultState

  const { data } = await fetchJSON('fetchWebcastCommunities', `${hostUrl || process.env.HOST}/service/community/v1?channelId=${channelId}&enabled=true`)

  return data || defaultState

}

export default fetchWebcastCommunities
